import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import useNotify from "./useNotify";
import { ImageField, useRefresh } from "react-admin";
import { Save, SaveAltOutlined } from "@mui/icons-material";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonCancel from "./CustomButtonCancel";
import CustomDialogTitle from "./CustomDialogTitle";
import CustomButtonSubmit from "./CustomButtonSubmit";
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const UploadLogoImage = ({ ...props }) => {
  const { id, uploadName, uploadApi, onSuccess, onError } = props;
  const showFileList = props?.showFileList ?? true;
  const { successNotify, errorNotify } = useNotify();
  const refresh = useRefresh();
  const [filelist, setFilelist] = React.useState<any[]>([]);
  const [tempImage, setTempImage] = React.useState<string>("");
  const [isUploading, setIsUploading] = React.useState(0);
  const handleFileChange = async (e) => {
    let file = e.target.files[0];
    let fileAize = file.size / 1024;
    if (fileAize > 1024) {
      errorNotify("File size should be less than 1MB");
      return false;
    }
    let fileNameType = file.name.split(".").pop();
    let fileType = ["jpg", "jpeg", "png"];
    if (fileType.indexOf(fileNameType) == -1) {
      errorNotify(
        "File type should be pdf, jpg, jpeg, png, doc, docx, xls, xlsx"
      );
      return false;
    }
    let fileName = file.name;
    if (file) {
      const formData = new FormData();
      formData.append(uploadName, file);

      const access_token = localStorage.getItem("access_token");
      const csrfToken = localStorage.getItem("csrfToken");
      setIsUploading(1);
      fetch(`${import.meta.env.VITE_API_URL}/` + uploadApi, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "X-CSRF-TOKEN": `${csrfToken}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data?.code == 200) {
            successNotify(
              "File uploaded successfully, Please preview and save"
            );
            setTempImage(data?.filepath);
            setFilelist((prev) => [...prev, data?.file]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
      setIsUploading(0);
    }
  };
  const handelSaveImage = () => {
    //uploadName
    sendRequest(uploadApi, {
      id: "save-logo",
      data: {
        type: "coverImage",
        fileName: uploadName,
        filePath: tempImage,
      },
    }).then((res) => {
      if (res?.code == 200) {
        successNotify("Saved successfully, will refresh to show updated image");
        if (onSuccess) {
          onSuccess(tempImage);
        }
        refresh();
      } else {
        errorNotify("Error saving " + res?.message);
      }
    });
    setTempImage("");
  };
  return (
    <>
      {/* {filelist.length > 0 && showFileList == true && (
        <div
          style={{
            width: "100%",
            background: "pink",
            minWidth: "100%",
            clear: "both",
          }}
        >
          <Box sx={{ width: "100%" }}>
            {filelist.map((item) => (
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Uploaded Files:
                {item}
              </Typography>
            ))}
          </Box>
        </div>
      )} */}

      {tempImage && (
        <Dialog
          open={tempImage ? true : false}
          id="upload-bank-logo"
          aria-labelledby="customized-dialog-title"
          onClose={() => setTempImage("")}
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle
            sx={{
              borderBottom: "1px solid #e5e5e5",
              mb: 2,
            }}
          >
            Logo Image Preview
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="customized-dialog-contenttext">
              <div
                style={{
                  marginTop: "20px",
                  paddingTop: "20px",
                  width: "100%",
                  minWidth: "100%",
                  clear: "both",
                  display: "block",
                  textAlign: "center",
                  paddingBottom: "20px",
                }}
              >
                <img src={tempImage} style={{ maxWidth: "200px", margin: 2 }} />
              </div>
              <Typography>
                Please click save to "save" and save the logo image for this
                institution.
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions
            id="customized-dialog-footer"
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <CustomButtonCancel onClick={() => setTempImage("")} />
            <Box sx={{ flexGrow: 1 }} />
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              startIcon={<Save />}
              sx={{ width: "120px", maxWidth: "500px", margin: "10px auto" }}
              disabled={props?.disabled ? true : false}
              onClick={handelSaveImage}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <div
        style={{
          width: "100%",
          minWidth: "100%",
          clear: "both",
          display: "inline-block",
        }}
      >
        {!tempImage && (
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            sx={{ width: "200px", maxWidth: "500px", mt: 1 }}
            disabled={props?.disabled ? true : false}
          >
            <VisuallyHiddenInput
              type="file"
              id={uploadName}
              name={uploadName}
              onChange={handleFileChange}
              disabled={isUploading}
            />{" "}
            Upload New
          </Button>
        )}
      </div>
    </>
  );
};

export default UploadLogoImage;
